import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { ActivityNotificationService } from "../../activity-notifications/activity-notification.service";
import { IUserActivity, UserActivity } from "./user-activity.model";
import { combineLatest, Observable, Subject } from "rxjs";
import { Store } from "@ngrx/store";
import * as fromStore from '../../store';
import { first } from "rxjs/operators";


@Injectable()
export class ActivityLogResolver implements Resolve<any|null> {

  constructor(
    private _activityNotificationService: ActivityNotificationService,
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IUserActivity[]> {
    return new Promise((resolve) => {
      combineLatest(
        this._store.select(fromStore.getWebsites),
        this._getActivities()
      )
        .pipe(
          first(([websites]) => !!websites, null),
        )
        .subscribe(([, userActivities]) => resolve(userActivities));
    });
  }

  private _getActivities(): Observable<IUserActivity[]> {
    const result$: Subject<IUserActivity[]> = new Subject<IUserActivity[]>();
    this._activityNotificationService.getUsersActivities().then(activities => {
      result$.next(activities.map(activity => new UserActivity(activity)));
        result$.complete();
      }).catch(() => {
        result$.next([]);
        result$.complete();
      });
    return result$;
  }
}
